import React from 'react';
import styled, { StyledComponent } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

export const withFilteredProps = (WrappedComponent, customShouldForwardProp) => {
  const FilteredComponent = React.forwardRef((props, ref) => {
    const filteredProps = Object.keys(props)
      .filter(prop => isPropValid(prop) && (customShouldForwardProp ? customShouldForwardProp(prop) : true))
      .reduce((acc, prop) => {
        acc[prop] = props[prop];
        return acc;
      }, {});

    return <WrappedComponent ref={ref} {...filteredProps} />;
  });

  return FilteredComponent;
};